export const convertIban = (iban) => {
  const convertedIban = iban.match(/.{1,4}/g).join(" ");
  return convertedIban;
};

export const capitalizeFirstLetter = (string) => {
  return string.charAt(0).toUpperCase() + string.slice(1);
}